import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

/**
 * ScrollToTop component
 * 
 * Scrolls to the top of the page whenever the route changes
 * This component doesn't render anything, it just performs the scroll action
 */
const ScrollToTop = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    // Instant scroll — smooth scroll-behavior on <html> can fight the first
    // touch scroll on iOS and feel like a rubber-band snap-back.
    window.scrollTo({ top: 0, left: 0, behavior: 'instant' });
  }, [pathname]);

  // This component doesn't render anything
  return null;
};

export default ScrollToTop; 